import type { PracticeEntity } from "./models/practices";

export const PRACTICE_VALIDATION_MESSAGES = {
  practiceIdRequired: "Practice ID is required",
  practiceTypeRequired: "Practice Type is required",
  zipCodeRequired: "ZIP Code is required",
  zipCodeFormat: "Invalid format. ZIP Code must contain 5 or 9 digits",
  zipCodeNotFound: "This is not a valid ZIP Code",
  zipCodeValidationFailure: "Failed to validate ZIP Code",
  descriptionRequired: "Description is required",
  macRequired: "MAC is required",
} as const;

export const ZIP_CODE_PARTIAL_REGEX = /^(\d{0,9}|\d{5}-\d{0,4})$/;
const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const formatZipCode = (zipCode: string | null | undefined): string => {
  const value = (zipCode ?? "").trim();

  if (!ZIP_CODE_PARTIAL_REGEX.test(value)) {
    return "";
  }

  const digits = value.replace("-", "");

  if (digits.length <= 5) {
    return digits;
  }

  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const zipCodeForRequest = (zipCode: string | null | undefined): string =>
  (zipCode ?? "").replace("-", "");

export const isValidZipCode = (zipCode: string | null | undefined): boolean =>
  ZIP_CODE_REGEX.test(zipCode ?? "");

export const validatePractice = (practice: PracticeEntity) => {
  const errors: string[] = [];

  if (!practice.Id) {
    errors.push(PRACTICE_VALIDATION_MESSAGES.practiceIdRequired);
  }

  if (!practice.PracticeType) {
    errors.push(PRACTICE_VALIDATION_MESSAGES.practiceTypeRequired);
  }

  if (!practice.ZipCode) {
    errors.push(PRACTICE_VALIDATION_MESSAGES.zipCodeRequired);
  } else if (!isValidZipCode(practice.ZipCode)) {
    errors.push(PRACTICE_VALIDATION_MESSAGES.zipCodeFormat);
  }

  if (!practice.Description) {
    errors.push(PRACTICE_VALIDATION_MESSAGES.descriptionRequired);
  }

  return errors;
};
